import React, { useContext, useEffect, useRef, useState } from "react";
import Chat from "../../../common/Chat";
import useChat from "../../../../hooks/useChat";
import AppContext from "../../../../AppContext";
import { PAGE_STATE } from "../../../../constants";
import Button from "../../../common/Button";
import ChatSessionContext from "../../../../contexts/ChatSessionContext";
import { ReactComponent as EmptyStateSvg } from "../../../../assets/admin/chat/empty-state.svg";
import { SocketContext } from "../../../../contexts/SocketContext";

const ChatLive = () => {
  const { querySessions, bookSessionByStaff, getSession } = useChat();
  const { user } = useContext(AppContext);
  const [pageState, setPageState] = useState(PAGE_STATE.LOADING);
  const [isHaveOpenRequests, setIsHaveOpenRequests] = useState(undefined);
  const { currentSession, setCurrentSession, getCurrentSession } =
    useContext(ChatSessionContext);
  const intervalRef = useRef(null);
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    init();

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const _gracefulSocketLeave = () => {
    // * Close socket support
    socket.emit(
      "message",
      JSON.stringify({
        event: "support-chat:leave",
      })
    );
    socket.off("support-chat:on-new-session", handleIncomingNewSupportSession);
    socket.off("support-chat:on-session-changed", handleIncomingChangeSession);
  };

  useEffect(() => {
    if (!socket) return;

    _gracefulSocketLeave();

    // * Open socket support
    socket.emit(
      "message",
      JSON.stringify({
        event: "support-chat:join",
      })
    );
    socket.on("support-chat:on-new-session", handleIncomingNewSupportSession);
    socket.on("support-chat:on-session-changed", handleIncomingChangeSession);

    return () => {
      _gracefulSocketLeave();
    };
  }, [socket, pageState]);

  const init = async () => {
    await fetchSession();

    intervalRef.current = setInterval(() => {
      fetchSession();
    }, 2000);
  };

  const fetchSession = async () => {
    if (getCurrentSession()) {
      return;
    }

    // * Check if a session is open
    const { data } = await querySessions({
      staff: user._id,
      closed: false,
      support: true,
    });

    // * Have live session
    if (data?.length > 0) {
      setCurrentSession(data[0]._id, user._id);
      setPageState(PAGE_STATE.IDLE);
      return;
    }

    // * No session opened, so get open chat requests
    const { data: openRequests } = await querySessions(
      {
        support: true,
        staff: null,
        closed: false,
        active: true,
        deleted: false,
      },
      1,
      1,
      {
        _id: 1,
      }
    );

    // * Have open requests
    if (openRequests.length > 0) {
      setIsHaveOpenRequests(true);
    }

    if (openRequests.length === 0) {
      setIsHaveOpenRequests(false);
    }

    setPageState(PAGE_STATE.IDLE);
  };

  const handleIncomingNewSupportSession = async (msg) => {
    const message = JSON.parse(msg);
    console.log("handleIncomingNewSupportSession", message);

    //TODO How to handleIncomingNewSupportSession
  };

  const handleIncomingChangeSession = async (msg) => {
    const message = JSON.parse(msg);
    //TODO How to handleIncomingChangeSession

    console.log("handleIncomingChangeSession", message);
  };

  const handleStartSupportClick = async () => {
    setPageState(PAGE_STATE.LOADING);

    // * Book chat
    const _session = await bookSessionByStaff();

    // * No session was booked
    if (!_session) {
      isHaveOpenRequests(false);
      setPageState(PAGE_STATE.IDLE);
    }

    setCurrentSession(_session._id, user._id);
    setPageState(PAGE_STATE.IDLE);
  };

  const handleOnChatReturn = () => {
    setCurrentSession(undefined);
    setPageState(PAGE_STATE.LOADING);
    setIsHaveOpenRequests(undefined);
    fetchSession();
  };

  if (
    !currentSession &&
    isHaveOpenRequests === undefined &&
    pageState !== PAGE_STATE.IDLE
  ) {
    return <>Loading</>;
  }

  if (isHaveOpenRequests && pageState !== PAGE_STATE.IDLE) {
    return <>Booking session</>;
  }

  if (currentSession) {
    return (
      <div className="admin-chat-live">
        <Chat
          sessionId={currentSession._id}
          userId={user._id}
          onReturn={handleOnChatReturn}
        />
      </div>
    );
  }

  if (isHaveOpenRequests === false) {
    return (
      <div className="admin-chat-live">
        <EmptyStateSvg className="admin-chat-live__empty-state" />
        <span className="admin-chat-live__sub">No live sessions available</span>
      </div>
    );
  }

  return (
    <div className="admin-chat-live">
      <span className="admin-chat-live__sub">
        Incoming support request available
      </span>
      <Button label="Start support" onClick={handleStartSupportClick} />
    </div>
  );
};

ChatLive.propTypes = {};

export default ChatLive;
